// @flow

// eslint-disable-next-line import/no-unresolved
import omnichannelChatWidgetResources from '@travel-frontend/omnichannel-chat-widget/locale/de-DE.json';
import {locale as sharedLocale} from '@travel-frontend/ui-components';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

import {config} from 'config';
import localData from 'locale';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: config.locale,
    defaultNS: 'general',
    resources: {
      [config.locale]: {
        ...sharedLocale[config.locale],
        ...localData[config.agent],
        livechat: omnichannelChatWidgetResources,
      },
    },
    react: {
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['b', 'br'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export {default} from 'i18next';
